import { html } from '@design.estate/dees-element';
import type { DeesHarnessMessageList } from './dees-harness-message-list.js';
import type { IHarnessMessage } from '../interfaces.js';

const seedMessages = (): IHarnessMessage[] => [
  {
    id: 'm1',
    role: 'user',
    text: 'Summarize the last deploy and tell me if anything regressed.',
    createdAt: Date.now() - 300_000,
  },
  {
    id: 'm2',
    role: 'assistant',
    text: 'The deploy finished in **4m12s**. One warning: the `sitemap` job took 3× longer than baseline.\n\n- build: ok\n- tests: 212 passed\n- sitemap: slow (see below)',
    createdAt: Date.now() - 280_000,
    reasoning: [
      {
        id: 'r1',
        text: 'Check the deploy log timings first, then compare against the previous run.',
        startedAt: Date.now() - 290_000,
        endedAt: Date.now() - 287_000,
      },
    ],
  },
  {
    id: 'm3',
    role: 'user',
    text: 'Dig into the sitemap job please.',
    createdAt: Date.now() - 200_000,
  },
];

let streamStop: (() => void) | undefined;

const simulateStream = (event: MouseEvent) => {
  streamStop?.();
  const container = (event.target as HTMLElement).closest('.listDemo');
  const list = container?.querySelector<DeesHarnessMessageList>('dees-harness-message-list');
  if (!list) return;
  const streamingMessage: IHarnessMessage = {
    id: `stream-${Date.now()}`,
    role: 'assistant',
    text: '',
    createdAt: Date.now(),
    streaming: true,
  };
  list.messages = [...list.messages, streamingMessage];
  const source = 'The sitemap job re-crawled every route because the cache key changed with the locale rollout. Pinning the cache key to the route manifest hash brings it back to baseline. I can prepare that patch.';
  let offset = 0;
  const interval = setInterval(() => {
    const chunk = source.slice(offset, offset + 5);
    offset += 5;
    if (!chunk) {
      clearInterval(interval);
      list.applyDelta({ type: 'message-end', messageId: streamingMessage.id, usage: { inputTokens: 900, outputTokens: 120, totalTokens: 1020 } });
      return;
    }
    list.applyDelta({ type: 'text', messageId: streamingMessage.id, delta: chunk });
  }, 40);
  streamStop = () => clearInterval(interval);
};

export const demoFunc = () => html`
  <style>
    .listDemo {
      display: grid;
      grid-template-rows: auto minmax(0, 1fr);
      gap: 12px;
      height: 520px;
      max-width: 720px;
      margin: 40px auto;
      padding: 16px;
      border-radius: var(--dees-radius-xl);
      background: var(--dees-color-bg-primary);
      border: 1px solid var(--dees-color-border-subtle);
    }
    .listDemo dees-harness-message-list {
      height: 100%;
    }
  </style>
  <div class="listDemo">
    <div>
      <dees-button @clicked=${simulateStream}>Stream a new reply</dees-button>
    </div>
    <dees-harness-message-list .messages=${seedMessages()}></dees-harness-message-list>
  </div>
  <style>
    .emptyDemo {
      height: 200px;
      max-width: 720px;
      margin: 0 auto 40px;
      border-radius: var(--dees-radius-xl);
      border: 1px solid var(--dees-color-border-subtle);
      background: var(--dees-color-bg-primary);
    }
    .emptyDemo dees-harness-message-list { height: 100%; }
  </style>
  <div class="emptyDemo">
    <dees-harness-message-list
      emptyTitle="Nothing here yet"
      emptyText="Send the agent a prompt to get started."
    ></dees-harness-message-list>
  </div>
`;
